import { Input, VStack } from '@chakra-ui/react'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CircleWizardFormData } from '../types'

export const NameStep = () => {
  const { t } = useTranslation()
  const { register } = useFormContext<CircleWizardFormData>()

  return (
    <VStack gap={6} width="1/2">
      <Input
        type="text"
        placeholder={t('communities.new.steps.name.placeholder')}
        size={{ base: 'lg', md: 'xl' }}
        {...register('name', { required: true })}
      />
    </VStack>
  )
}
